import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const expectedItems = ['list', 'grid']

export interface useViewTypeResult {
  viewType: 'list' | 'grid'
  setViewType: (viewType: string) => void
}

type PropTypes = {
  initialViewType?: string
}

const useSelectView = ({ initialViewType = 'list' }: PropTypes): useViewTypeResult => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const [viewType, setCurrentViewType] = useState(
    searchParams.has('viewType') ? searchParams.get('viewType') : initialViewType,
  )

  useEffect(() => {
    // Update URL with the view type
    const updatedSearchParams = new URLSearchParams(window.location.search)

    // Clear the view type if it's null or an empty string
    if ((viewType ?? '') === '') {
      updatedSearchParams.delete('viewType')
    } else {
      updatedSearchParams.set('viewType', viewType ?? '')
    }

    // Replace the current state in the history without adding a new entry
    window.history.replaceState(null, '', `${window.location.pathname}?${updatedSearchParams.toString()}`)
  }, [viewType])

  // Reset the view type if an unexpected value
  useEffect(() => {
    if (!expectedItems.includes(viewType ?? '')) {
      setCurrentViewType(initialViewType)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewType])

  const setViewType = (viewType: string) => {
    setCurrentViewType(viewType)
  }

  return {
    viewType: viewType?.toString() as useViewTypeResult['viewType'],
    setViewType,
  }
}

export default useSelectView
